import * as XLSX from 'xlsx';

// Turns a display name into a filename-safe slug, e.g. "Acme Agency Co." ->
// "acme-agency-co".
export const slugify = (value) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Prepends a 1-based "Sr.No" column to every row, ahead of whatever fields
// the caller passed in - required on every sheet in every export.
const withSerialNumbers = (rows) => rows.map((row, index) => ({ 'Sr.No': index + 1, ...row }));

// Converts an array of plain objects into a downloaded single-sheet .xlsx
// file. Column order/labels come straight from each row's own keys, so
// callers should pass already-shaped row objects (not raw API records with
// internal-only fields) rather than this function trying to guess what to
// include.
export function exportToExcel(filename, rows) {
  const worksheet = XLSX.utils.json_to_sheet(withSerialNumbers(rows));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, `${filename}.xlsx`);
}

// Same as exportToExcel, but for a single downloaded workbook containing
// multiple named sheets - `sheets` is an array of { name, rows }.
export function exportWorkbookToExcel(filename, sheets) {
  const workbook = XLSX.utils.book_new();
  sheets.forEach(({ name, rows }) => {
    const worksheet = XLSX.utils.json_to_sheet(withSerialNumbers(rows));
    XLSX.utils.book_append_sheet(workbook, worksheet, name);
  });
  XLSX.writeFile(workbook, `${filename}.xlsx`);
}
